<template>
	<div
		class="audio-blocked-warning no-highlight"
		:style="heightStyle"
		tabindex="-1"
	>
		<ExclamationIcon style="margin-left: 10px;" />
		<span style="margin-left: 10px;">{{
			$t('meetings_audio_disabled_alert')
		}}</span>
		<!-- No need for click event because there's a global event handler that will enable audio -->
		<button
			:aria-label="$t('meetings_audio_enable_label')"
			class="no-highlight"
		>
			{{ $t('meetings_audio_enable_label') }}
		</button>

		<a
			v-if="show"
			class="how-to"
			href="https://support.pronto.io/en/articles/4261934-grant-access-to-microphone-camera-and-screen-recording"
			target="_blank"
			:aria-label="$t('meetings_audio_enable_how')"
			:aria-hidden="show"
			>{{ $t('meetings_audio_enable_how') }}</a
		>
	</div>
</template>

<script>
import { ExclamationIcon } from '@/icons'

export default {
	name: 'AudioBlockedWarning',
	props: { show: { type: Boolean, default: null }},
	components: { ExclamationIcon },
	computed: {
		heightStyle() {
			return { height: this.show ? '45px' : '0' }
		},
	},
}
</script>

<style lang="scss" scoped>
.audio-blocked-warning {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	height: 0;
	display: flex;
	align-items: center;
	font-size: 12px;
	color: #4f5053;
	background: #fff;
	border-left: 4px solid #f9bb22;
	overflow: hidden;
	transition: height ease-in 0.2s;
	width: 100%;
	z-index: 10;
	button {
		font-family: Avenir-Medium;
		font-size: 12px;
		margin-left: 32px;
		padding: 8px 16px;
		border-radius: 20px;
		background-color: #eeeeee;
		color: #4f5053;
	}
}

.how-to {
	position: fixed;
	top: 14px;
	right: 20px;
	font-family: Avenir-Medium;
	font-size: 12px;
	color: #5a91f9;
	text-decoration: none;
}
</style>
